export default {
  URL: process.env.REACT_APP_URL ?? 'http://localhost:3000',
  LOGIN_URL: (process.env.REACT_APP_NEO_ADMIN_URL ?? 'http://localhost:5000') + '/login',
  LOGOUT_URL: (process.env.REACT_APP_NEO_ADMIN_URL ?? 'http://localhost:5000') + '/logout',
};